import React, { useState } from "react";
import {
  CircleDashed,
  CalendarX,
  Shirt,
  Wind,
  BatteryLow,
  Frown,
  Check,
} from "lucide-react";
import { DIAGNOSTICO } from "@/content";
import WhatsAppButton from "@/components/WhatsAppButton";
import Reveal from "@/components/Reveal";

const ICONS = { CircleDashed, CalendarX, Shirt, Wind, BatteryLow, Frown };

export default function Diagnostico() {
  const [marcados, setMarcados] = useState([]);

  const toggle = (id) =>
    setMarcados((prev) =>
      prev.includes(id) ? prev.filter((x) => x !== id) : [...prev, id]
    );

  const n = marcados.length;
  const mostrar = n >= 3;

  return (
    <section
      className="py-16 md:py-24"
      style={{ background: "var(--crema)" }}
      data-testid="section-diagnostico"
      id="diagnostico"
    >
      <div className="container-page">
        <Reveal className="text-center">
          <h2 className="h2-display" style={{ color: "var(--vino)" }}>
            {DIAGNOSTICO.h2}
          </h2>
          <p className="mt-3 text-[16px]" style={{ color: "var(--gris)" }}>
            {DIAGNOSTICO.sub}
          </p>
        </Reveal>

        <div className="mt-9 grid grid-cols-2 md:grid-cols-3 gap-3 md:gap-5">
          {DIAGNOSTICO.items.map((item, i) => {
            const Icon = ICONS[item.icon] || CircleDashed;
            const active = marcados.includes(item.id);
            return (
              <Reveal key={item.id} delay={i * 80}>
                <button
                  type="button"
                  onClick={() => toggle(item.id)}
                  aria-pressed={active}
                  data-testid={`sintoma-${item.id}`}
                  className="relative w-full h-full text-left p-4 md:p-6 transition-all duration-300"
                  style={{
                    background: active ? "var(--lima-soft)" : "var(--blanco)",
                    border: active
                      ? "2px solid var(--lima)"
                      : "2px solid rgba(107,31,58,0.07)",
                    borderRadius: 16,
                    boxShadow: active
                      ? "0 12px 30px rgba(139,197,63,0.22)"
                      : "var(--shadow-soft)",
                    cursor: "pointer",
                  }}
                >
                  {active && (
                    <span
                      className="absolute flex items-center justify-center rounded-full"
                      style={{
                        top: 10,
                        right: 10,
                        width: 24,
                        height: 24,
                        background: "var(--lima)",
                      }}
                      aria-hidden="true"
                    >
                      <Check size={15} strokeWidth={3} color="#fff" />
                    </span>
                  )}
                  <span
                    className="flex items-center justify-center rounded-full mb-3 transition-colors"
                    style={{
                      width: 56,
                      height: 56,
                      background: active ? "var(--blanco)" : "var(--rosa-soft)",
                    }}
                  >
                    <Icon
                      size={28}
                      strokeWidth={2}
                      style={{ color: active ? "var(--lima)" : "var(--vino)" }}
                    />
                  </span>
                  <span
                    className="font-display block"
                    style={{
                      fontSize: 17,
                      lineHeight: 1.2,
                      color: "var(--vino)",
                      fontWeight: 700,
                    }}
                  >
                    {item.text}
                  </span>
                </button>
              </Reveal>
            );
          })}
        </div>

        {/* Resultado dinámico */}
        <div
          aria-live="polite"
          className="overflow-hidden transition-all duration-500"
          style={{
            maxHeight: mostrar ? 460 : 0,
            opacity: mostrar ? 1 : 0,
            transform: mostrar ? "translateY(0)" : "translateY(16px)",
          }}
        >
          <div
            className="mt-8 mx-auto max-w-[640px] text-center p-6 md:p-9"
            style={{
              background: "var(--blanco)",
              border: "2px solid var(--lima)",
              borderRadius: 24,
              boxShadow: "var(--shadow-mid)",
            }}
            data-testid="diagnostico-resultado"
          >
            <p
              className="font-display"
              style={{ fontSize: 28, color: "var(--vino)" }}
            >
              {DIAGNOSTICO.resultadoTitulo(n)}
            </p>
            <p className="mt-3" style={{ color: "var(--carbon)" }}>
              {DIAGNOSTICO.resultadoTexto}
            </p>
            <div className="mt-6">
              <WhatsAppButton section="diagnostico" full className="sm:w-auto" />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
